import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/core';
import { SubSink } from 'subsink';
import { submitBtnAnimation } from '../../../animation/submit-btn.anim';

@Component({
  selector: 'app-submit-btn',
  templateUrl: './submit-btn.component.html',
  styleUrls: ['./submit-btn.component.scss'],
  animations: [submitBtnAnimation],
})
export class SubmitBtnComponent implements OnInit {
  @Output('animationComplete') animComplete: EventEmitter<null>;
  @Output('animationStart') animationStart: EventEmitter<null>;
  @Input('title') title!: string;
  @Input('loading') loading!: boolean;
  @Input('ready') ready: boolean = false;
  @Input('anim-options') animationOptions!: AnimationOptions;
  @Input('anim-style') animStyle = {
    width: '230px !important',
    position: 'absolute',
    top: '-12px',
    right: 0,
  };

  public animationUp!: boolean;
  public lottieAnimation!: AnimationItem;
  public animationControl: boolean = false;
  public animationRunning: boolean = false;
  public subsink = new SubSink();

  constructor(
    private _ngZone: NgZone,
    private authService: AuthService,
    private snackbar: MatSnackBar
  ) {
    this.animComplete = new EventEmitter();
    this.animationStart = new EventEmitter();
  }

  ngOnInit(): void {
    this.animationUp = false;
  }

  onAnimationLoaded(animation: any) {
    this.lottieAnimation = animation;
  }

  @HostListener('click', ['$event'])
  async startSubmitAnimation(event: any): Promise<any> {
    let userIsLoggedIn = await this.authService.isLoggedIn();

    if (userIsLoggedIn) {
      if (this.animationRunning && this.loading && !this.ready) {
        return;
      }

      if (this.lottieAnimation) {
        this.runAnimation();
      } else {
        this.animComplete.emit();
      }
    } else {
      const authBoxResult = await firstValueFrom(
        this.authService.openAuthBox('')?.afterClosed()!
      );

      if (authBoxResult) {
        this.runAnimation();
        userIsLoggedIn = true;
      } else {
        this.subsink.sink = this.snackbar
          .open('لطفا قبل از ثبت سفارش وارد سایت شوید', 'ورود به سایت', {
            duration: 3000,
          })
          .afterDismissed()
          .subscribe((data: { dismissedByAction: boolean }) => {
            if (data.dismissedByAction) {
              this.startSubmitAnimation('');
            }
          });
      }
    }
  }

  runAnimation() {
    this.animationRunning = true;
    this.animationUp = false;

    this._ngZone.runOutsideAngular(() => {
      this.lottieAnimation.play();
      this.animationStart.emit();
    });
  }

  stopSubmitAnimation() {
    this.animationUp = true;
    this._ngZone.runOutsideAngular(() => {
      this.lottieAnimation.stop();
    });
  }

  moveBackgroundUp() {
    this.animationUp = true;
  }

  onComplete(event: unknown) {
    this.animationUp = true;
    this.animationRunning = false;

    this.animComplete.emit();
  }
}
